<app-layout-dialogLessheader [title]="issuetitle" [titlesub]="''" mat-dialog-title></app-layout-dialogLessheader>
<mat-dialog-content>
    <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
    <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
    <div class="issue-edit-steep container-fluid container-clean">

        <div class="row issue container-clean">
            <div class="issue-canvas-main-container col container-clean">
                <h5 class="step"><span class="bs-stepper-circle active">1</span> Select Issue area from image <span
                        class="text-secondary">{{image.name}}</span> on flight: <span
                        class="text-secondary">{{flight.name}}</span></h5>
                <div class="issue-canvas">
                    <app-issuecanvas #issue_canvas [issue]="issue" [bgimage]="imageurl" [issueList]="issueList"
                        [width]="640" [height]="512" [editIssueOnCanvas]="true" [canvas_options]="canvas_options"></app-issuecanvas>
                    <div class="button-nav-navigation btn-group d-flex justify-content-end">
                        <button type="button" class="btn btn-secondary" (click)="imageFirst($event)"
                            matTooltip="First item (Ctrl+Left arrow)">
                            <i class="fas fa-angle-double-left"></i>
                        </button>
                        <button type="button" class="btn btn-secondary" (click)="imagePrev($event)"
                            matTooltip="Previous item (Left arrow)">
                            <i class="fas fa-angle-left"></i>
                        </button>
                        <button type="button" class="btn btn-secondary" (click)="imageNext($event)"
                            matTooltip="Next item (Right arrow)">
                            <i class="fas fa-angle-right"></i>
                        </button>
                        <button type="button" class="btn btn-secondary" (click)="imageLast($event)"
                            matTooltip="Last item (Ctrl+Right arrow)">
                            <i class="fas fa-angle-double-right"></i>
                        </button>
                    </div>
                    
                </div>

                <div class="btn-group-vertical" role="group" style="width: 36px;">
                    <button type="button" class="btn btn-secondary" (click)="resetCanvas()"
                        matTooltip="Reset view and data"><i class="fas fa-redo-alt"></i></button>
                    <div class="mb-1"></div>
                    <button type="button" class="btn btn-outline-secondary" (click)="zoomin($event)"
                        matTooltip="Zoom in"><i class="fas fa-search-plus"></i></button>
                    <button *ngIf="zoomShowMinus" type="button" class="btn btn-outline-secondary"
                        (click)="zoomout($event)" matTooltip="Zoom out"><i class="fas fa-search-minus"></i></button>

                    <!-- <button type="button" class="btn btn-outline-secondary" (click)="filtergray($event)" 
                    matTooltip="Set to grayscale"><i class="fas fa-adjust"></i></button>  -->
                    <!-- <button type="button" class="btn btn-outline-secondary" (click)="filterInvert($event)" 
                    matTooltip="Set to grayscale and invert"><i class="fas fa-tint"></i></button>  -->
                    <div class="mb-1"></div>
                    <button type="button" class="btn btn-outline-secondary" (click)="filtergrayscale($event)"
                        matTooltip="Set to grayscale"><i class="fas fa-adjust"></i></button>
                    <button type="button" class="btn btn-outline-secondary" (click)="filterInvert($event)"
                        matTooltip="Set invert"><i class="fas fa-tint"></i></button>
                    <button type="button" class="btn btn-outline-secondary" (click)="adjustTemperature($event)"
                        matTooltip="Adjust temperature"><i class="fas fa-sliders-h"></i></button>
                    <!-- <button type="button" class="btn btn-secondary" (click)="addrect()"><i class="far fa-minus-square"></i></button>
                    <button type="button" class="btn btn-secondary"><i class="far fa-trash-alt"></i></button> -->
                    <!-- <button type="button" class="btn btn-outline-secondary" (click)="imageNext($event)" 
                    matTooltip="Next image"><i class="fas fa-arrow-circle-right"></i></button> 
                    <button type="button" class="btn btn-outline-secondary" (click)="imagePrev($event)" 
                    matTooltip="Previous image"><i class="fas fa-arrow-circle-left"></i></button>  -->
                </div>


            </div>
            <div class="col issue-finded-col">
                <div class="issue-actions btn-issue-err btn-row">
                    <h5 class="step"><span class="bs-stepper-circle active">2</span> Select Issue type</h5>
                    <button type="button" class="btn btn-sm btn-outline-primary"
                        [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.E1PC)"
                        (click)="issueChangeError(issue,issueTypeEnum.E1PC)" matTooltip="Mark errors as Hot Spot">
                        <app-ex-issuerrortype [errortype]="issueTypeEnum.E1PC">
                        </app-ex-issuerrortype> Hot Spot
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-primary"
                        [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.PCS)"
                        (click)="issueChangeError(issue,issueTypeEnum.PCS)"
                        matTooltip="Mark errors as Several Hot Spots">
                        <app-ex-issuerrortype [errortype]="issueTypeEnum.PCS">
                        </app-ex-issuerrortype> N Hot Spots
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-primary"
                        [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.E1CC)"
                        (click)="issueChangeError(issue,issueTypeEnum.E1CC)" matTooltip="Mark errors as Hot Cell">
                        <app-ex-issuerrortype [errortype]="issueTypeEnum.E1CC">
                        </app-ex-issuerrortype> Hot Cell
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-primary"
                        [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.CCS)"
                        (click)="issueChangeError(issue,issueTypeEnum.CCS)"
                        matTooltip="Mark errors as Several Hot Cells">
                        <app-ex-issuerrortype [errortype]="issueTypeEnum.CCS">
                        </app-ex-issuerrortype> N Hot Cells
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-primary"
                        [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.SMC)"
                        (click)="issueChangeError(issue,issueTypeEnum.SMC)" matTooltip="Mark errors as Bypass diode">
                        <app-ex-issuerrortype [errortype]="issueTypeEnum.SMC">
                        </app-ex-issuerrortype> Bypass diode
                    </button>

                    <button type="button" class="btn btn-sm btn-outline-primary"
                        [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.PID)"
                        (click)="issueChangeError(issue,issueTypeEnum.PID)"
                        matTooltip="Mark errors as Potencial-induced degradation">
                        <app-ex-issuerrortype [errortype]="issueTypeEnum.PID">
                        </app-ex-issuerrortype> Potencial-induced degradation
                    </button>

                    <button type="button" class="btn btn-sm btn-outline-primary"
                        [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.DRT)"
                        (click)="issueChangeError(issue,issueTypeEnum.DRT)" matTooltip="Mark errors as Dirt">
                        <app-ex-issuerrortype [errortype]="issueTypeEnum.DRT">
                        </app-ex-issuerrortype> Dirt
                    </button>

                    <button type="button" class="btn btn-sm btn-outline-primary"
                        [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.SDW)"
                        (click)="issueChangeError(issue,issueTypeEnum.SDW)" matTooltip="Mark errors as Shadows">
                        <app-ex-issuerrortype [errortype]="issueTypeEnum.SDW">
                        </app-ex-issuerrortype> Shadow
                    </button>

                    <button type="button" class="btn btn-sm btn-outline-primary"
                        [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.FUS)"
                        (click)="issueChangeError(issue,issueTypeEnum.FUS)" matTooltip="Mark errors as broken fuses">
                        <app-ex-issuerrortype [errortype]="issueTypeEnum.FUS">
                        </app-ex-issuerrortype> Fuses
                    </button>

                    <button type="button" class="btn btn-sm btn-outline-primary"
                        [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.BRK)"
                        (click)="issueChangeError(issue,issueTypeEnum.BRK)" matTooltip="Mark errors as broken">
                        <app-ex-issuerrortype [errortype]="issueTypeEnum.BRK">
                        </app-ex-issuerrortype> Broken
                    </button>

                    <button type="button" class="btn btn-sm btn-outline-primary"
                        [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.DSC)"
                        (click)="issueChangeError(issue,issueTypeEnum.DSC)"
                        matTooltip="Mark errors as disconnected panel">
                        <app-ex-issuerrortype [errortype]="issueTypeEnum.DSC">
                        </app-ex-issuerrortype> Disconnected
                    </button>


                    <button type="button" class="btn btn-sm btn-outline-primary"
                        [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.SHC)"
                        (click)="issueChangeError(issue,issueTypeEnum.SHC)" matTooltip="Mark error as short circuit">
                        <app-ex-issuerrortype [errortype]="issueTypeEnum.SHC">
                        </app-ex-issuerrortype> Short circuit
                    </button>

                    <button type="button" class="btn btn-sm btn-outline-primary"
                        [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.DLM)"
                        (click)="issueChangeError(issue,issueTypeEnum.DLM)" matTooltip="Mark error as delamination">
                        <app-ex-issuerrortype [errortype]="issueTypeEnum.DLM">
                        </app-ex-issuerrortype> Delamination
                    </button>

                </div>
                <h5 class="step"><span class="bs-stepper-circle active">3</span> Find Issue</h5>
                <div class="issue-actions btn-issue-err" style="overflow: auto;">
                    <div *ngIf="!findingIssue" class="issue-actions-find-buttons">
                        <button type="button" class="btn btn-sm btn-outline-primary btn-block mr-2"
                            [disabled]="findingIssue" (click)="findissue_click(true)"
                            matTooltip="Find nearest issue for selected area. If no issue found use 'Find issue in area'">
                            <i class="fas fa-search"></i> Find nearest issue
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-secondary btn-block"
                            [disabled]="findingIssue" (click)="findissue_click(false)"
                            matTooltip="Find issue on selected area.">
                            <i class="fas fa-search"></i> Find issue in area
                        </button>
                    </div>

                    <div *ngIf="findingIssue">
                        <p class="mt-1 text-danger" style="font-size: 110%;">
                            <span *ngIf="findingIssue" class="spinner-border spinner-border-sm mr-1"></span>
                            Searching issue on selected area. Please wait.
                        </p>
                    </div>
                    <div *ngIf="!findingIssue && issueNotFound">
                        <p class="mt-3 text-danger" style="font-size: 1rem;">
                            <i class="fas fa-exclamation-circle"></i>
                            {{issueNotFound}}
                        </p>
                    </div>
                </div>
                <div class="issue-container mt-3" *ngIf="issueFinded">
                    <h4><i class="fas fa-check text-success"></i> Issue finded</h4>
                    <div><b>Panel: </b>
                        <span>{{issue?.info?.panel?.name}}</span>
                        <span class="panelmessageinfo text-danger" *ngIf="panelMessage"><i
                                class="alert-icon fas fa-exclamation-triangle"></i> {{panelMessage}}</span></div>
                    <div class="locator-container">
                        <app-panellocator #panellocator [issue]="issue"
                            (panelChangeEvent)="panellocator_panelChangeEvent_handler($event)"></app-panellocator>
                    </div>
                    <app-issuethermal [issue]="issue" [options]="{showDate:false}"></app-issuethermal>
                    <p class="mt-1 text-secondary" style="font-size: 90%;">
                        <i class="fas fa-info-circle"></i> Check the result and save it. If panel is not correct you can
                        move after saved.
                    </p>
                </div>

            </div>
        </div>
    </div>
</mat-dialog-content>
<div mat-dialog-actions style="width:100%;" class="justify-content-end mat-dialog-actions">
    <div class="mr-2" [innerHtml]="infomessage"></div>
    <button mat-raised-button type="button" (click)="confirmIssue_click()" [disabled]="!isvalid2Save()||submitted"
        class="btn btn-success pull-right"><i class="far fa-save"></i> Create New Issue</button>

    <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</div>